import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/buttons/buttons";
import Input from "../../../../components/inputs/inputs";
import { cleanInput } from "../../../../helpers/cleanInput";
import { Beat } from "../../../../plugins/spinners.plugin";
import {
  showApplication,
  updateApplication,
} from "../../../../redux/applicationSettings/applicationAction";

export default function PlatformRatesSettings() {
  const dispatch = useDispatch();
  const { updating, settings } = useSelector((state) => state.application);
  const [data, setData] = useState({
    // percentage: settings?.platform_charges?.service_fee?.percentage,
    // limit: settings?.platform_charges?.service_fee?.limit,
    // status: settings?.platform_charges?.service_fee?.status,
    platform_charges: {
      service_fee: {
        percentage: settings?.platform_charges?.service_fee?.percentage || "",
        status: settings?.platform_charges?.service_fee?.status || "",
        minimum_limit:
          settings?.platform_charges?.service_fee?.minimum_limit || "",
        maximum_limit:
          settings?.platform_charges?.service_fee?.maximum_limit || "",
      },
    },
  });

  useEffect(() => {
    dispatch(showApplication());
  }, [dispatch]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "service_fee_percentage") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            percentage: value,
          },
        },
      }));
    } else if (name === "service_fee_limit_min") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            minimum_limit: value,
          },
        },
      }));
    } else if (name === "service_fee_limit_max") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            maximum_limit: value,
          },
        },
      }));
    } else if (name === "service_fee_status") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            status: value,
          },
        },
      }));
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleUpdate = async () => {
    cleanInput(data);
    // const response = dispatch(
    //   updateApplication({
    //     platform_charges: {
    //       service_fee: {
    //         ...data,
    //       },
    //     },
    //   })
    // );
    const response = dispatch(updateApplication({ ...data }));
    if (response.status === "success") {
      dispatch(showApplication());
    }
  };
  return (
    <>
      <div className="w-100 mx-auto">
        <div className="mx-auto bg-white dark:bg-[#121212] sm:w-[630px] w-full mt-10 sm:mt-0 sm:border p-6 sm:border-gray-200 dark:border-none">
          <div className="border-b dark:border-[#505050] py-4 mb-6">
            <p className="text-base font-medium flex justify-center ">
              Platform Rates
            </p>
          </div>

          <form className="sm:px-10">
            <div className="mb-10">
              <div className="border dark:border-[#505050] mb-3 px-2 py-3">
                <h4 className="font-bold">Service Fee (%) :</h4>
                <p className="text-gray-400 text-sm">
                  Percentage charged per checkout{" "}
                </p>
              </div>
              <Input.Number
                title={"Service Fee Percentage (%)"}
                type="number"
                name="percentage"
                id="percentage"
                // defaultValue={data?.percentage || ""}
                defaultValue={
                  settings?.platform_charges?.service_fee?.percentage
                }
                placeholder={"0.0"}
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm flex-1"
                onChange={handleChange}
              />
            </div>

            <div className="mb-10">
              <div className="border dark:border-[#505050] mb-3 px-2 py-3">
                <h4 className="font-bold ">Service Fee Limit (NGN):</h4>
                <p className="text-gray-400 text-sm">
                  Minimum and maximum amount for % charged per checkout
                </p>
              </div>
              {/* <Input.Number
                title={"Limit"}
                type="number"
                name="limit"
                id="limit"
                defaultValue={data?.limit || ""}
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm flex-1"
                placeholder="NGN 0.00"
                onChange={handleChange}
              /> */}
              <Input.Number
                title={"Service Fee Limit (Mininum)"}
                htmlFor={"service_fee_limit_min"}
                name={"service_fee_limit_min"}
                onChange={handleChange}
                defaultValue={
                  settings?.platform_charges?.service_fee?.minimum_limit
                }
                placeholder={"0"}
              />
              <Input.Number
                title={"Service Fee Limit (Maximum)"}
                htmlFor={"service_fee_limit_max"}
                name={"service_fee_limit_max"}
                onChange={handleChange}
                defaultValue={
                  settings?.platform_charges?.service_fee?.maximum_limit
                }
                placeholder={"0"}
              />
            </div>

            <div className="mb-10">
              <div className="border dark:border-[#505050] mb-3 px-2 py-3">
                <h4 className="font-bold ">Service Fee Status:</h4>
                <p className="text-gray-400 text-sm">
                  Enable or disable the service fee feature
                </p>
              </div>
              <div className="mb-10">
                <Input.Select
                  title={"Status"}
                  name="status"
                  htmlFor={"status"}
                  // defaultValue={data?.status}
                  defaultValue={settings?.platform_charges?.service_fee?.status}
                  onChange={handleChange}
                >
                  <option>Select Status</option>
                  <option value={"available"}>Available</option>
                  <option value={"unavailable"}>Unavailable</option>
                </Input.Select>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="flex justify-center mx-auto">
        <Button.Primary
          disabled={updating}
          title={updating ? <Beat color={"#ffffff"} /> : "Save Changes"}
          className={"px-4 rounded-sm sm:mt-10"}
          onClick={handleUpdate}
        />
      </div>
    </>
  );
}
